export default __webpack_public_path__ + "static/media/a037-student-t3-5.96be3794.svg";